import Password from './components/Password';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'password',
  pluginComponent: Password,
});
